// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"3aef906a","453":"593125b2","934":"d2e068a1"}[chunkId] + ".chunk.js";
};